<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container fluid>
            <div class="d-flex mb-4">
                <h2>{{ $t('deforestation.complianceCertification') }}</h2>
                <v-spacer></v-spacer>
            </div>

            <v-card elevation="0" class="px-5">
                <v-card-text>
                    <v-data-table :headers="tableHeaders" :items="complianceCertifications" :items-per-page="10"
                        :header-props="{
                            'sort-icon': 'mdi-unfold-more-horizontal',
                        }" :footer-props="{
    'items-per-page-options': [10, 25, 50],
}" hide-default-footer :loading="loading" :options.sync="options" :server-items-length="totalDeforestations"
                        :loading-text="$t('deforestation.loadingDeforestationComplianceReport')">
                        <template v-slot:top="{ }">
                            <div class="d-flex mt-5">
                                <v-text-field prepend-inner-icon="mdi-magnify" @keyup.enter="searchQuery" outlined
                                    height="5px" :placeholder="$t('search')" dense v-model="search" class="shrink">
                                </v-text-field>

                                <v-btn class="mx-2 py-5 " @click="resetSearchOnEmpty">
                                    <v-icon dark>
                                        autorenew
                                    </v-icon>
                                </v-btn>
                                <!-- all countries -->
                                <v-select class="mx-2" :items="countries" :label="$t('deforestation.allCountries')" outlined
                                    dense>
                                </v-select>

                                <!-- all regions -->
                                <v-select class="mx-2" :items="allRegions" :label="$t('deforestation.allRegions')" outlined
                                    dense>
                                </v-select>

                                <!-- farms -->
                                <v-select class="mx-2" :items="allFarms" :label="$t('deforestation.allFarms')" outlined
                                    dense>
                                </v-select>

                                <!-- status -->
                                <v-select class="mx-2" :items="allStatus" :label="$t('deforestation.allStatus')" outlined
                                    dense>
                                </v-select>

                                <v-spacer></v-spacer>
                                <div class="py-1 title">
                                    {{ options.page }} - {{ totalPages }} of {{ totalComplianceCertifications }}
                                </div>
                                <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page <= 1"
                                    @click="pageChange(false)">
                                    <v-icon dark>
                                        mdi-chevron-left
                                    </v-icon>
                                </v-btn>
                                <v-btn class="mx-2" fab small outlined color="primary"
                                    :disabled="options.page >= totalPages" @click="pageChange(true)">
                                    <v-icon dark>
                                        mdi-chevron-right
                                    </v-icon>
                                </v-btn>

                                <v-menu v-model="customizeMenu" :close-on-content-click="false" :nudge-width="200" left
                                    :min-width="417">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on">
                                            <v-icon dark> mdi-cog-outline </v-icon>
                                        </v-btn>
                                    </template>

                                    <v-card width="417">
                                        <v-list>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{
                                                        $t("farm.customization")
                                                    }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider></v-divider>
                                            <div class="pl-3 pt-2 font-weight-normal">
                                                {{ $t("farm.recordsPerpage") }}
                                            </div>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-slider v-model="itemsPerPageSlider"
                                                        :tick-labels="itemsPerPageOptions" :max="3" step="1" ticks="always"
                                                        tick-size="4"></v-slider>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mt-n3"></v-divider>
                                        </v-list>
                                        <v-card-text>
                                            <v-container fluid>
                                                <v-row>
                                                    <v-col class="mt-n9" cols="6" v-for="header in headers"
                                                        :key="header.value">
                                                        <v-checkbox v-if="header.text.length > 0" v-model="selectedHeaders"
                                                            :label="header.text" color="primary" :value="header.text"
                                                            hide-details :disabled="header.text == 'ID' || header.text == 'Tag'
                                                                "></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>
                                        <v-layout justify-center>
                                            <v-card-actions class="mb-5">
                                                <v-spacer></v-spacer>

                                                <v-btn outlined color="primary" @click="resetDefault" width="190">
                                                    {{ $t("farm.restoreDefault") }}
                                                </v-btn>
                                                <v-btn color="primary" @click="resetTableStructure" width="190">
                                                    {{ $t("farm.apply") }}
                                                </v-btn>
                                            </v-card-actions>
                                        </v-layout>
                                    </v-card>
                                </v-menu>
                            </div>
                        </template>
                        <template v-if="complianceCertifications.length" v-slot:body="{ items }">
                            <tbody>
                                <tr v-for="item in items" :key="item.id" style="position: relative; width: 0; height: 0"
                                    @mouseover="selectItem(item)" @mouseleave="selectItem(false)">
                                    <template>
                                        <td class="text-truncate">
                                            {{ item.farmName ? item.farmName : "N/A" }}
                                        </td>

                                        <td class="text-truncate">
                                            {{ item.locationName ? item.locationName : 'N/A' }}
                                        </td>


                                        <td class="text-truncate">
                                            {{ getDateFormat(item.createdAt) }}
                                        </td>

                                        <td>
                                            <div style="position: absolute; right: 10px; top:10px;">
                                                <v-icon class="primary--text"
                                                    @click="$router.push({ name: 'ComplianceCertificationEudrAssessment', params: { id: item.id } })">mdi-eye</v-icon>
                                            </div>
                                        </td>
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                        <template v-slot:footer></template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import download from "@/mixins/DownloadMixin";
import getPermittedActions from "@/mixins/GetPermittedActions";
import DateMixin from '@/mixins/DateMixin';
// import DeforestationService from "@/_services/DeforestationService";
import moment from "moment";
import gql from 'graphql-tag'
export default {

    computed: {
        totalPages() {
            return parseInt(Math.ceil(this.totalComplianceCertifications / 10))
        },
        getCurrentUser() {
            return this.$store.getters.getUser
        }
    },
    mounted() {
        this.tableHeaders = this.headers;
        this.selectedHeaders = this.allSelectedHeaders;
    },
    watch: {
        options: {
            handler(opt) {
                this.getComplianceCertification(opt);
            },
            deep: true,
        },
    },
    data() {
        return {
            complianceCertifications: [
            ],
            countryModel: 'All Countries',
            statusModel: 'All Statuses',
            regionModel: 'All Regions',
            farmModel: 'All Farms',
            countries: [
                { text: this.$t('deforestation.allCountries'), val: 'All Countries' },
                { text: 'USA', val: 'USA' }
            ],
            allStatus: [
                { text: this.$t('deforestation.allStatus'), val: 'All Statuses' },
                { text: this.$t('pending'), val: 'pending' },
                { text: this.$t('approved'), val: 'approved' },
                { text: this.$t('rejected'), val: 'rejected' },
            ],
            allRegions: [
                { text: this.$t('deforestation.allRegions'), val: 'All Regions' },
                { text: 'St PR', val: 'St.Taxas' }
            ],
            allFarms: [
                { text: this.$t('deforestation.allFarms'), val: 'All Farms' },
                { text: 'avocadoo farm', val: 'Avocado farms' }
            ],
            loading: false,
            totalComplianceCertifications: 1,
            tab: 0,
            selectedItem: false,
            options: {
                itemsPerPage: 10,
                page: 1
            },
            search: "",
            from: 1,
            to: 0,
            headers: [
                {
                    text: this.$t("farm.farmName"),
                    align: "start",
                    value: "farmName",
                    class: "black--text",
                },
                {
                    text: this.$t("farm.farmLocation"),
                    align: "start",
                    value: "farmLocation",
                    class: "black--text",
                    sortable: true,
                },
                {
                    text: this.$t("farm.dateOfRequest"),
                    align: "start",
                    value: "dateOfRequest",
                    class: "black--text",
                    sortable: true,
                },
                {
                    text: '',
                    align: "center",
                    value: "status",
                    class: "black--text",
                    sortable: false,
                },
            ],
            breadcrumbs: [
                {
                    text: this.$t("dashboard"),
                    disabled: false,
                    to: { name: "Users" },
                    exact: true,
                },
                {
                    text: this.$t("deforestation.complianceCertification"),
                    disabled: true,
                    href: "breadcrumbs_link_1",
                },
            ],
            customizeMenu: false,
            itemsPerPageSlider: '',
            itemsPerPageOptions: [5, 10, 25, 50],
            customizeMenuAll: '',
            selectedHeaders: [
            ],
            tableHeaders: [

            ],
            allSelectedHeaders: [
                this.$t("deforestation.farmName"),
                this.$t("deforestation.farmLocation"),
                this.$t("deforestation.dateOfRequest")
            ]
        };
    },
    methods: {
        async getComplianceCertification(opt) {
            this.loading = true;
            const requestParams = {
                page: this.options.page,
                limit: this.options.itemsPerPage,
                searcPhrase: this.search,
            }
            if (opt?.sortBy?.length) {
                requestParams.orderField = opt.sortBy[0]
                requestParams.order = opt.sortDesc[0] ? 'DESC' : 'ASC'
            }
            await this.$apollo.queries.complianceCertifications.refetch();
            this.loading = false;
            // DeforestationService.getComplianceCertifications(requestParams).then(res => {
            //     console.log(res)
            //     this.complianceCertifications = res.data.deforestationAdmin.rows
            //     this.totalComplianceCertifications = res.data.deforestationAdmin.totalCount
            //     this.loading = false
            // }).catch(err => {
            //     this.loading = false
            //     console.log(err)
            // })
        },
        selectItem(item) {
            this.selectedItem = item;
        },
        searchQuery() {
            this.options = {
                itemsPerPage: 10,
                page: 1,
            },
                this.getComplianceCertification();
        },
        resetSearchOnEmpty() {
            this.search = ''
            this.options = {
                itemsPerPage: 10,
                page: 1,
            },
                this.getComplianceCertification();
        },
        pageChange(t) {
            if (t) this.options.page = this.options.page + 1;
            else this.options.page = this.options.page - 1;
            this.getComplianceCertification();
        },

        getDateFormat(date) {
            return moment(date).format("YYYY/MM/DD");
        },

        resetTableStructure() {
            this.startLoading();
            this.tableHeaders = this.headers.filter((header) =>
                this.selectedHeaders.includes(header.text.toString())
            );
            this.customizeMenu = false;
            this.stopLoading();
        },

        resetDefault() {
            this.tableHeaders = this.headers;
            this.selectedHeaders = this.allSelectedHeaders;
            this.menu = false;
        },
    },
    mixins: [loadingMixin, download, getPermittedActions, DateMixin],
    apollo: {
        complianceCertifications: {
            query() {
                return gql`query certificates($page: Int!, $limit: Int!, $search: String!, $adminReportType: String!) {
					certificates(getCertificateInput:{search: $search, page: $page, limit: $limit, adminReportType: $adminReportType}) {
						rows {
                            id
							farmName
                            locationName
                            createdAt
						}
						count
						totalCount
					}
				}`
            },
            variables() {
                return {
                    page: this.options.page,
                    limit: this.options.itemsPerPage,
                    search: this.search,
                    adminReportType: "certification"
                }
            },
            update: data => data.certificates,
            result({ data }) {
                this.loading = false;
                this.startLoading()
                this.complianceCertifications = data.certificates.rows
                this.totalDeforestations = data.certificates.totalCount
                this.totalPages = Math.ceil(
                    this.totalDeforestations / this.options.itemsPerPage
                )
                this.from = (this.options.page - 1) * this.options.itemsPerPage + 1
                this.to =
                    this.options.page * this.options.itemsPerPage -
                    (this.options.itemsPerPage - data.certificates.count)

                setTimeout(() => {
                    this.stopLoading()
                }, 500)
            },
            fetchPolicy: 'no-cache',
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .wdt.v-text-field {
    width: 250px;
}

::v-deep .v-tab:hover {
    background-color: #caf1e2;
    color: $primary_color !important;
}

::v-deep .v-data-table-header span {
    color: black;
}

::v-deep .center-content {
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep .img-center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 40%;
}
</style>
  